import { SvgIconTypeMap } from '@mui/material';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import { Biotech, Sensors } from '@mui/icons-material';

export interface MethodologyItem {
  title: string;
  description: string;
  items: string[];
  gradient: string;
  borderColor: string;
  icon: OverridableComponent<SvgIconTypeMap<{}, "svg">> & { muiName: string };
  iconColor: string;
}

export const methodologiesData: MethodologyItem[] = [
  {
    title: 'Metodologías Avanzadas',
    description: 'Vixia System desarrolla metodologías avanzadas para detectar contaminantes, evaluar la calidad de aguas dulces en fuentes y humedales, y aplicar técnicas de biorremediación en procesos industriales de depuración acuática.',
    items: [
      'Detección de contaminantes',
      'Evaluación de calidad en aguas dulces',
      'Análisis en fuentes y humedales',
      'Técnicas de biorremediación',
      'Depuración acuática industrial',
      'Teledetección satelital'
    ],
    gradient: 'linear-gradient(135deg, rgba(30, 64, 175, 0.2) 0%, rgba(59, 130, 246, 0.2) 100%)',
    borderColor: 'rgba(96, 165, 250, 0.3)',
    icon: Biotech,
    iconColor: '#93c5fd'
  },
  {
    title: 'Algoritmos y Predicción',
    description: 'Vixia System desarrolla algoritmos avanzados para la detección de pigmentos, permitiendo el estudio de especies de microalgas tóxicas en embalses y estuarios. Empleamos teledetección espectral y modelos de aprendizaje automático para lograr una identificación precisa y temprana. Además, trabajamos en la predicción de eventos tóxicos —como floraciones algales nocivas— en embalses y aguas costeras, integrando datos ambientales y productos derivados de satélites.',
    items: [],
    gradient: 'linear-gradient(135deg, rgba(139, 92, 246, 0.2) 0%, rgba(167, 139, 250, 0.2) 100%)',
    borderColor: 'rgba(167, 139, 250, 0.3)',
    icon: Sensors,
    iconColor: '#d8b4fe'
  }
];